import type React from 'react'

import placeholder from '@images/placeholder-wide.jpg'
import { Image } from '@nextui-org/react'
import { memo } from 'react'

import type { GalleryImage } from './lib/type'

interface FigureImageProps {
  image: GalleryImage
}

export const FigureImage = memo(
  ({ image }: Readonly<FigureImageProps>): React.JSX.Element => {
    const srcSet = image?.sizes
      ? Object.entries(image.sizes)
          .map(([size, { url, width }]) => `${url} ${width}w`)
          .join(', ')
      : ''

    return (
      <figure className="relative aspect-[3/4] h-full w-full">
        <Image
          alt={image.alt}
          className="h-full w-full object-cover object-center"
          fallbackSrc={placeholder}
          removeWrapper
          src={image.url}
          srcSet={srcSet}
        />
      </figure>
    )
  },
)

FigureImage.displayName = 'FigureImage'

export default FigureImage
